import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { useApiEcomClientError } from '~/src/common/services/error-handler/error-handler';
import { isApiEcomError } from '~/src/common/utils/guards';

export const useProductContentErrorHandler = (error: unknown) => {
  const { push } = useRouter();
  const handleError = useApiEcomClientError();

  useEffect(() => {
    if (!isApiEcomError(error)) return;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises  -- auto-ignored when updating eslint
    if (error.statusCode === 404) push('/404');
    else handleError(error);
  }, [error, push, handleError]);
};
